// extracted by css-extract-rspack-plugin
export default {"newValue":"ChangeEventView_newValue__5eO-6"};